import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { validate, validators } from 'validate-redux-form';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';

import {
    renderField,
    renderNumber,
    SelectField
} from "../../Utils/renderField/renderField";

function ProyectosForm(props) {
    const { handleSubmit, crear, obtenerTipos, lectura, modulo } = props;
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar Proyecto' : 'Crear Proyecto';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver Proyecto'
    }
    
    let autoFocus = true;
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            <div className='mb-2 w-25'>
                                <Field
                                    autoFocus={autoFocus}
                                    name="codigo"
                                    placeholder="Codigo"
                                    className="form-control"
                                    component={renderNumber}
                                    disabled={editar ? true : disabled}
                                    msj="Código"
                                />
                                    
                            </div>

                            <div className='mb-2 w-50'>
                                <Field
                                    name="proyecto"
                                    placeholder="Proyecto"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Proyecto"
                                />
                            </div>

                            <div className='mb-2 w-50'>
                                <Field
                                    name="ubicacion"
                                    placeholder="Ubicacion"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Ubicación"
                                />
                            </div>

                            <div className='mb-2 w-50'>
                                <Field
                                    name="responsable"
                                    placeholder="Responsable"
                                    className="form-control"
                                    component={renderField}
                                    disabled={disabled}
                                    msj="Responsable"
                                />
                            </div>
                            
                            <div className='mb-2 w-25'>
                            {obtenerTipos &&
                                <div className="form-floating">
                                    <Field
                                        name="tipo"
                                        options={obtenerTipos}
                                        crear={crear}
                                        dato={crear === true ? 0 : lectura.tipo_obra}
                                        component={SelectField}
                                        className="form-select"
                                        disabled={disabled}
                                        msj="Tipo de obra"
                                    />
                                </div>
                            }
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={handleSubmit}
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                <a
                                    href={`/#/inmobiliaria/${id_emp[5]}/proyectos`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ProyectosForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    obtenerTipos: PropTypes.array,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormProyecto',
    validate: (data) => {
        return validate(data, {
            codigo: validators.exists()('Este campo es requerido'),
            proyecto: validators.exists()('Este campo es requerido'),
        });
    },
})(ProyectosForm);
